import React, { useState } from "react";

const Statistics = ({ stats = [] }) => {
  const [loading, setLoading] = useState(true);
  if (!stats.length) return null; // Optionally show a loader or nothing

  return (
    <section className='py-16 bg-secondary-dark text-white'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-2 md:grid-cols-4 gap-8 text-center'>
          {stats.map((stat, index) => (
            <div key={index}>
              <div className='text-4xl md:text-5xl font-bold text-primary mb-2'>
                {stat.number}
              </div>
              <div className='text-sm text-gray-300'>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
